import Icon from "../Icon";

export function Spinner({ size = 16 }) {
  return <span className="spinner" style={{ width: size, height: size }} />;
}


export function Skeleton({ w = "100%", h = 14, style }) {
  return (
    <span
      className="skeleton"
      style={{ display: "block", width: w, height: h, ...style }}
    />
  );
}


export function SkeletonRows({ rows = 6, cols = 5 }) {
  return (
    <div style={{ padding: "var(--sp-4)" }} className="stack gap-3">
      {Array.from({ length: rows }, (_, r) => (
        <div key={r} className="row gap-4">
          {Array.from({ length: cols }, (_, c) => (
            <Skeleton key={c} w={c === 0 ? "22%" : "14%"} h={16} />
          ))}
        </div>
      ))}
    </div>
  );
}


/* ------------------------------ ESTADOS ------------------------------- */
export function EmptyState({ icon = "inbox", title, text, action }) {
  return (
    <div className="empty">
      <div className="empty-icon">
        <Icon name={icon} size={24} />
      </div>
      <p className="empty-title">{title}</p>
      {text && <p className="empty-text">{text}</p>}
      {action}
    </div>
  );
}


export function ErrorState({ message, onRetry }) {
  return (
    <div className="empty">
      <div
        className="empty-icon"
        style={{ background: "var(--bad-tint)", color: "var(--bad)" }}
      >
        <Icon name="alert" size={24} />
      </div>
      <p className="empty-title">No se pudo cargar</p>
      <p className="empty-text">{message}</p>
      {onRetry && (
        <button className="btn btn-outline" onClick={onRetry}>
          <Icon name="refresh" size={15} /> Reintentar
        </button>
      )}
    </div>
  );
}
